import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTrainingRecord, fetchTrainingHistory } from '../../../features/staffTraining/staffTrainingActions';
export default function useTrainingRecord(id, staffId) {
  const dispatch = useDispatch();
  const state = useSelector(store => staffId ? store.staffTraining.histories[staffId] : store.staffTraining.records[id]);
  useEffect(() => {
    const value = staffId || id;
    if (!/^\d+$/.test(String(value)) || Number(value) < 1) return;
    const request = dispatch(staffId ? fetchTrainingHistory(staffId) : fetchTrainingRecord(id));
    return () => request.abort();
  }, [dispatch, id, staffId]);
  if (!/^\d+$/.test(String(staffId || id)) || Number(staffId || id) < 1) return { error: 'Invalid training record or staff ID.', loading: false };
  return state || { loading: true };
}
